import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const fieldLabelSx = {
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
  alignItems: "flex-start",
};

function ContactField({ label, value }) {
  return (
    <MDBox sx={fieldLabelSx}>
      <MDTypography variant="caption" fontWeight="medium" color="secondary">
        {label}
      </MDTypography>
      <MDTypography variant="body2" color="text" sx={{ wordBreak: "break-word" }}>
        {value || "N/A"}
      </MDTypography>
    </MDBox>
  );
}

ContactField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function CustomerContactsMobileCards({
  contacts,
  loading,
  onViewContact,
  emptyMessage,
}) {
  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" py={3}>
        <CircularProgress size={28} />
      </MDBox>
    );
  }

  if (!contacts?.length) {
    return (
      <MDBox display="flex" justifyContent="center" py={3}>
        <MDTypography variant="body2" color="text">
          {emptyMessage}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox display="flex" flexDirection="column" gap={2}>
      {contacts.map((contact) => (
        <Card
          key={contact.customer_contact_id ?? `${contact.name}-${contact.telephone}`}
          variant="outlined"
          sx={{ overflow: "hidden" }}
        >
          <MDBox p={2}>
            <MDBox display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
              <MDBox minWidth={0} flex={1}>
                <MDTypography variant="button" fontWeight="medium" sx={{ wordBreak: "break-word" }}>
                  {contact.name || "N/A"}
                </MDTypography>
                {contact.primary === "yes" ? (
                  <MDTypography variant="caption" color="success" fontWeight="medium">
                    Primary contact
                  </MDTypography>
                ) : null}
              </MDBox>
              <MDButton
                variant="text"
                color="info"
                onClick={() => onViewContact(contact.customer_contact_id)}
                sx={{ minWidth: "auto", flexShrink: 0, p: "6px" }}
              >
                <VisibilityIcon />
              </MDButton>
            </MDBox>

            <Divider sx={{ my: 1.5 }} />

            <MDBox display="flex" flexDirection="column" gap={1.25}>
              <ContactField label="Telephone" value={contact.telephone} />
              <ContactField label="WhatsApp" value={contact.whatsapp} />
              <ContactField label="Email" value={contact.email} />
              <ContactField
                label="Primary"
                value={contact.primary === "yes" ? "Yes" : "No"}
              />
            </MDBox>
          </MDBox>
        </Card>
      ))}
    </MDBox>
  );
}

CustomerContactsMobileCards.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  onViewContact: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string,
};

CustomerContactsMobileCards.defaultProps = {
  loading: false,
  emptyMessage: "No contacts found",
};

export default CustomerContactsMobileCards;
